export default {"src":"/_next/static/media/domestic-logistics-firm.7eac1f8e.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};